// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// Some configs can be set via the dashboard:
// https://docs.sentry.io/pricing/quotas/manage-event-stream-guide/#rate-limiting

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.2.9";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/assets/seller_ui";globalThis["_sentryAssetPrefix"] = "/assets/seller_ui";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import { init } from '@sentry/nextjs';

import { getRuntimeConfig } from '@catawiki/next-config/runtime-config';
import { getClientInitOptions } from '@catawiki/observability';

import {
  getClientSentryEventContext,
  shouldIgnoreClientSentryEvent,
} from './src/shared/utils/sentry/clientIgnoreRules';

const runtimeConfig = getRuntimeConfig();
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN; // stored in .env.build
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE; // provided via cloudbuild
const GOOGLE_ADS_CONVERSION_SPAN_PATTERNS = [
  /^GET https:\/\/www\.googleadservices\.com\/pagead\/conversion\//,
  /^GET https:\/\/(www\.)?google\.com\/pagead\/1p-conversion\//,
  /^GET https:\/\/googleads\.g\.doubleclick\.net\/pagead\/viewthroughconversion\//,
];

if (!dsn || !release) {
  console.warn(
    '[Sentry] Skipping client initialization because NEXT_PUBLIC_SENTRY_DSN or NEXT_PUBLIC_SENTRY_RELEASE is missing'
  );
} else {
  const initOptions = getClientInitOptions({
    dsn,
    environment:
      runtimeConfig.environment ?? runtimeConfig.stage ?? 'production',
    release,
    sampleRate: {
      production: 0.25,
      staging: 1,
      development: 0,
    },
    tracesSampleRate: {
      // Increasing this value will lead to faster quota drain
      production: 0.1,
      staging: 1,
      development: 0,
    },
  });

  const baseBeforeSend = initOptions.beforeSend;

  init({
    ...initOptions,
    enableLogs: true,
    // Marketing conversion requests are intentionally noisy and trigger false N+1 signals.
    ignoreSpans: [
      ...(initOptions.ignoreSpans || []),
      ...GOOGLE_ADS_CONVERSION_SPAN_PATTERNS,
    ],
    beforeSend(event, hint) {
      const context = getClientSentryEventContext(event, hint);

      if (shouldIgnoreClientSentryEvent(context)) {
        return null;
      }

      // Preserve and extend the shared filtering from @catawiki/observability.
      return baseBeforeSend ? baseBeforeSend(event, hint) : event;
    },
  });
}
